import { useEffect } from 'react'
import { useNinetailed } from '@ninetailed/experience.js-react'
import { getBrowserName, getOs } from '@/utils/user-info'
export default function TrackPage() {
  const { page, identify } = useNinetailed()

  const getTheme = () => {
    let theme = localStorage.getItem('theme')

    switch (theme) {
      case '"dark"':
        return 'user set: dark mode'
      case '"light"':
        return 'user set: light mode'
      default:
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'system: dark mode' : 'system: light mode'
    }
  }

  useEffect(() => {
    if (typeof window.ninetailed !== 'undefined') {
      page()

      identify('', {
        browser: getBrowserName(),
        os: getOs(),
        theme: getTheme(),
      })

      let intervalId

      const checkForClearbitData = () => {
        const clearbitData = window.dataLayer?.find((item) => item['1'] === 'user_properties')
        if (clearbitData?.[2]) {
          identify('', clearbitData[2])
          if (intervalId) {
            clearInterval(intervalId)
          }
        }
      }

      // poll dataLayer clearbit
      if (window.dataLayer) {
        intervalId = setInterval(() => {
          checkForClearbitData()
        }, 20)

        setTimeout(() => {
          if (intervalId) {
            clearInterval(intervalId)
          }
        }, 500)
      }
      checkForClearbitData()
    }
  }, [page])

  return null
}
